export default __webpack_public_path__ + "static/media/phase5-bg.4acfc344.svg";